<template>
  <!-- 活动管理 -->
  <div>
    <div class="activityManage" v-if="createStep == 1">
      <div class="topbox" v-show="actItemInfo">
        <div>活动管理</div>
      </div>
      <!-- 头部表单查询 -->
      <!-- <input-form ref="inputForm" :btnPosition1="true" :inputData="inputData" :pageName="pageName" @toParentVal="searchForm"></input-form> -->
      <div class="tabSwitch" v-show="actItemInfo">
        <div
          class="tabSwitch-wz"
          @click="handleTab(index)"
          v-for="(item, index) in tabSwitchList"
          :key="index"
          :class="{ active: index == currIndex }"
        >
          {{ item }}
        </div>
      </div>
      <el-form
        ref="form"
        class="formClass"
        :model="form"
        label-position="right"
        label-width="100px"
        v-show="actItemInfo"
      >
        <el-form-item label="活动名称：">
          <el-input
            style="width: 280px;"
            size="small"
            placeholder="请输入"
            v-model="form.activityName"
          ></el-input>
        </el-form-item>

        <el-form-item label="活动类型：" style="min-width: 484px;">
          <el-select
            v-model="form.activityNewMainTypes"
            placeholder="请选择"
            @change="selectList"
            style="margin-right: 10px;"
          >
            <el-option
              v-for="item in selectArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select v-model="form.activityType" placeholder="请选择">
            <el-option
              v-for="item in selectArr1"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <div class="seach_btn">
          <el-button size="small" class="search" @click="handkeSearch(0)">
            查询
          </el-button>
          <el-button size="small" class="reset" @click="handkeSearch(1)"
            >重置</el-button
          >
        </div>
      </el-form>
      <div class="table_tip">
        <el-button
          @click="handleSetConfig"
          size="small"
          style="width: auto;background-color:#7b61ff;color:white;border: 1px solid #7b61ff"
          >活动配置</el-button
        >
        <div class="win_search" @click="handleWinSearch">中奖查询</div>
      </div>
      <!-- 表格内容 -->
      <template v-if="activityNewMainTypes == 6">
        <giftList
          ref="giftList"
          style="margin: -24px;"
          :statisType="2"
          :inputShow="false"
          @statisDataCreate="statisDataCreate"
          @handleshow="handleshow"
        ></giftList>
      </template>
      <template v-else-if="activityNewMainTypes == 7">
        <member ref="member" @handleAnysis="handleAnysis"></member>
      </template>

      <template v-else>
        <el-table
          :data="activityList"
          v-loading="talbeLoading"
          style="width: 100%; margin-top: 20px"
          ref="table"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img
                src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
              />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column label="活动名称" width="280">
            <template slot-scope="scope">
              <div class="activityName">
                <el-popover
                  v-if="form.status != 5"
                  placement="top-start"
                  width="500"
                  trigger="hover"
                >
                  <p style="margin: 20px">
                    请用手机京东扫描下面二维码查看您店铺的活动详情
                  </p>
                  <!-- <img src="" alt="活动二维码" style="margin-left: 60px" /> -->
                  <!-- <div class="qrcode" :id="'qrcode' + scope.row.id" :ref="'qrcode' + scope.row.id" style="margin-left: 80px"></div> -->
                  <qrcode-vue
                    class="qrcode"
                    :id="'qrcode' + scope.row.id"
                    :ref="'qrcode' + scope.row.id"
                    :size="qrcodeVue.size"
                    :value="scope.row.idUrl"
                    :logo="qrcodeVue.logo"
                    :bgColor="qrcodeVue.bgColor"
                    :fgColor="qrcodeVue.fgColor"
                    style="margin-left: 80px"
                  ></qrcode-vue>
                  <div>
                    <p style="margin: 20px">
                      链接地址：(手机京东店铺中活动详情链接地址)
                    </p>
                    <el-input
                      v-if="scope.row.pcUrl"
                      readonly
                      v-model="scope.row.pcUrl"
                      style="margin: 0 20px; width: 220px"
                    ></el-input
                    >
                    <el-input
                      v-else
                      readonly
                      v-model="scope.row.idUrl"
                      style="margin: 0 20px; width: 220px"
                    ></el-input
                    ><el-button
                      type="primary"
                      v-clipboard:copy="scope.row.pcUrl || scope.row.idUrl"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      >复制</el-button
                    >
                    <el-button
                      type="primary"
                      @click="handleSrcImg(scope.row.id)"
                      >下载</el-button
                    >
                  </div>
                  <img
                    v-if="
                      scope.row.activityType != 13 &&
                        scope.row.activityType != 14 &&
                        scope.row.activityType != 15
                    "
                    src="../../../assets/images/integralCenter/list_code.svg"
                    alt="活动二维码"
                    class="code"
                    slot="reference"
                  />
                </el-popover>
                <el-tooltip
                  effect="light"
                  :content="scope.row.activityName"
                  placement="top"
                  v-if="scope.row.activityType == 41"
                >
                  <div class="act-name">{{ scope.row.activityName }}</div>
                </el-tooltip>
                <span v-else>{{ scope.row.activityName }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="活动类型">
            <template slot-scope="scope">
              <span v-if="scope.row.activityType == 1"> 签到赢好礼</span>
              <span v-if="scope.row.activityType == 2"> 浏览礼品有礼 </span>
              <span v-if="scope.row.activityType == 3"> 每日限时抢 </span>
              <span v-if="scope.row.activityType == 4"> 关注店铺有礼 </span>
              <span v-if="scope.row.activityType == 5"> 邀请开卡有礼 </span>
              <span v-if="scope.row.activityType == 6"> 邀请关注有礼 </span>
              <span v-if="scope.row.activityType == 7"> 完善信息有礼 </span>
              <span v-if="scope.row.activityType == 8"> 幸运抽奖 </span>
              <span v-if="scope.row.activityType == 13">开卡礼包</span>
              <span v-if="scope.row.activityType == 14">店铺礼包</span>
              <span v-if="scope.row.activityType == 15"
                >店铺礼包（千人千面）</span
              >
              <span v-if="scope.row.activityType == 16">下单有礼</span>
              <span v-if="scope.row.activityType == 17">首单专享礼</span>
              <span v-if="scope.row.activityType == 18">复购有礼</span>
              <span v-if="scope.row.activityType == 19">下单抽奖</span>
              <span v-if="scope.row.activityType == 20">评价有礼</span>
              <span v-if="scope.row.activityType == 21">裂变神券</span>
              <span v-if="scope.row.activityType == 22">天降红包雨</span>
              <span v-if="scope.row.activityType == 23">欢乐娃娃机</span>
              <span v-if="scope.row.activityType == 24">大家来找茬</span>
              <span v-if="scope.row.activityType == 27">预售有礼</span>
              <span v-if="scope.row.activityType == 28">预售抽奖</span>
              <span v-if="scope.row.activityType == 31">超级裂变券</span>
              <span v-if="scope.row.activityType == 34">加购有礼</span>
              <span v-if="scope.row.activityType == 36">下单冲榜</span>
              <span v-if="scope.row.activityType == 39">生日有礼</span>
              <span v-if="scope.row.activityType == 41">晒单有礼</span>
              <span v-if="scope.row.activityType == 44">会员升级礼</span>
              <span v-if="scope.row.activityType == 50">情书贺卡</span>
            </template>
          </el-table-column>

          <el-table-column label="活动时间">
            <template slot-scope="scope">
              <div class="activityTime" v-if="form.status != 5">
                <span>起: {{ scope.row.startTime }}</span>
                <span>止: {{ scope.row.endTime }}</span>
                <span style="color: #7b61ff;">{{ scope.row.days }}</span>
              </div>
              <div class="activityTime2" v-else>
                <span>{{
                  scope.row.startTime ? scope.row.startTime : "-"
                }}</span>
                <span class="activityTime2_line">至</span>
                <span>{{ scope.row.endTime ? scope.row.endTime : "-" }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="最后修改时间" prop="updateTime">
          </el-table-column>
          <el-table-column v-if="form.status != 5" label="活动状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" class="state y1">未开始 </span>
              <span v-if="scope.row.status == 2" class="state y2">进行中 </span>
              <span v-if="scope.row.status == 3" class="state y3">已结束 </span>
              <el-tooltip
                class="item"
                effect="light"
                v-if="scope.row.reason && scope.row.status == 3"
                :content="scope.row.reason"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="参与人数"
            width="120"
            prop="joinNum"
            v-if="tabSwitchList[currIndex] != '草稿箱'"
          >
            <template slot-scope="scope">
              {{ scope.row.joinNum || 0 }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="320">
            <template slot-scope="scope">
              <div v-if="form.status != 5" class="editList">
                <span
                  v-if="
                    scope.row.status == 1 ||
                      (scope.row.status == 2 &&
                        typeFilter(scope.row.activityType))
                  "
                  @click="
                    modify(
                      scope.row.activityType,
                      scope.row,
                      'edit',
                      scope.row.status
                    )
                  "
                  class="edit"
                >
                  修改
                </span>
                <span v-else style="color: #999;" class="edit">
                  修改
                </span>
                <span @click="statisData(scope.row)" class="count"
                  >数据统计</span
                >
                <span
                  @click="modify(scope.row.activityType, scope.row, 'look')"
                  class="edit"
                >
                  查看
                </span>
                <span
                  @click="modify(scope.row.activityType, scope.row, 'copy')"
                  class="edit"
                >
                  复制
                </span>
                <span
                  v-if="scope.row.status == 2"
                  @click="endenActivity(scope.row.id)"
                  class="end"
                  >结束</span
                >
                <span v-else style="color: #999;" class="edit">
                  结束
                </span>
                <span
                  @click="deleteActivity(scope.row)"
                  class="delete"
                  style="color: #F56C6C;"
                  >删除</span
                >
                <span
                  v-if="scope.row.activityType == 19"
                  @click="addWhiteList(scope.row)"
                  class="edit"
                  >白名单</span
                >
                <!-- 其他活动的占位 -->
                <span v-else class="no-white"></span>
              </div>
              <div v-else>
                <el-button
                  type="text"
                  class="draft-btn"
                  @click="editDraft(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  class="draft-btn"
                  @click="delDraft(scope.row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="recordData.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="recordData.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          class="pagination"
        >
        </el-pagination>
      </template>
    </div>

    <!-- 创建活动步骤 -->
    <points-task-activity
      ref="createSte"
      class="marginClass"
      v-if="createStep == 2"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></points-task-activity>

    <!-- 创建活动步骤 -->
    <create-activity-step
      v-if="createStep == 4"
      class="marginClass"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityDataTwo"
      :stepNum="stepNum"
      :ids="ids"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      :isSave="isSave"
    ></create-activity-step>
    <!-- 下单抽奖 -->
    <create-activity-step2
      v-if="createStep == 19"
      class="marginClass"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityDataTwo"
      :stepNum="stepNum"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      :ids="ids"
    ></create-activity-step2>

    <!-- 电铺礼包千人千面 -->
    <create-task-electric
      class="marginClass"
      v-if="createStep == 15"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-electric>

    <!-- 首单  下单  复购 -->
    <create-task-polite
      class="marginClass"
      v-if="createStep == 16"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-polite>
    <!-- 裂变  评价  红包雨 -->
    <create-task-evaluation
      class="marginClass"
      v-if="createStep == 20"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      :statusComment="statusComment"
    ></create-task-evaluation>
    <!-- 数据统计-旧版 -->
    <statistics
      class="marginClass"
      style="background-color: #fff;"
      v-if="createStep == 3 && !isNew"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics>
    <!-- 数据统计-新版 -->
    <statistics-new
      class="marginClass"
      style="background-color: #fff"
      v-if="createStep == 3 && isNew"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics-new>
    <!-- v3.4邀请开卡有礼 -->
    <create-invite-step
      class="marginClass"
      ref="createSte"
      v-if="createStep == 5"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-invite-step>
    <!-- 游戏 -->
    <points-task-games
      class="marginClass"
      v-if="createStep == 23"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></points-task-games>

    <!-- 预售 -->
    <create-task-book
      class="marginClass"
      v-if="createStep == 27"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-book>
    <!-- 超级裂变 -->
    <create-task-superFission
      class="marginClass"
      v-if="createStep == 31"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-superFission>

    <!-- 下单冲榜 -->
    <create-Activity-Order
      ref="createStep36"
      v-if="createStep == 36"
      :stepNum="stepNum"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      class="marginClass"
    ></create-Activity-Order>

    <!-- 生日有礼 -->
    <create-brithday
      class="marginClass"
      v-if="createStep == 39"
      ref="createStep39"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-brithday>

    <!-- 会员升级礼 -->
    <member-upgrade-page
      class="marginClass"
      v-if="createStep == 44"
      ref="createStep44"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></member-upgrade-page>

    <!-- 情书贺卡 -->
    <billetDouxGreetingCard
      class="marginClass"
      v-if="createStep == 50"
      ref="createStep50"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></billetDouxGreetingCard>

    <!-- 晒单有礼 -->
    <create-singles-politely
      class="marginClass"
      v-if="createStep == 41"
      ref="createStep41"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      :isSave="isSave"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-singles-politely>

    <memberdataanalysis
      v-if="createStep == 12"
      :pageName="'数据统计'"
      @returnBack="returnBackChange"
      :ids="ids"
    ></memberdataanalysis>
    <dataAnalysis
      v-if="createStep == 11"
      :pageName="'数据统计'"
      @returnBack="returnBackChange"
      :ids="ids"
    ></dataAnalysis>
    <!-- 中奖查询 -->
    <winSearch
      v-if="createStep == 500"
      @returnBack="returnBackChange"
    ></winSearch>
    <!-- 结束活动弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >是否结束活动？</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisibleTwo"
      width="400px"
      :before-close="closehandleDeleteTwo"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >是否删除活动？</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDeleteTwo">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTableTwo">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 活动配置弹框 -->
    <el-dialog
      title="活动配置"
      :visible.sync="isShowActivityConfig"
      width="500px"
      :before-close="beforeConfigclose"
    >
      <div
        style="display: flex; flex-direction: column;line-height: 16px;"
        v-loading="configLoading"
      >
        <div style="margin-bottom: 20px;">勾选如下配置后保存表示对应规则：</div>
        <div style="margin-left: 15px;">
          <el-checkbox
            v-model="activityConfig.checkExistOrder"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <span style="margin-left: 10px;"
            >同类型活动下，同个订单只能被解锁成功1次（生效活动：首购有礼、复购有礼、下单有礼、下单抽奖、预售有礼、预售抽奖）</span
          >
          <el-popover
            placement="top-start"
            width="400"
            offset="100"
            trigger="hover"
            content="该配置仅在单类型的活动生效，不跨类型活动；比如：下单有礼有3个活动，则一个订单在其中一个活动解锁成功后不能在其它两个活动解锁；"
          >
            <span slot="reference">
              <p class="question_icon">?</p>
            </span>
          </el-popover>
        </div>
      </div>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="isShowActivityConfig = false"
          >取 消</el-button
        >
        <el-button
          class="b2"
          style="margin: 0 10px;"
          @click="handleConfirmConfig"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <!-- 白名单弹窗 -->
    <white-list
      v-if="showWhiteList"
      v-model="showWhiteList"
      :whiteRow="whiteRow"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "@/components/inputForm";
import pointsTaskActivity from "../points_task_activity";
import createInviteStep from "../points_task_Invite";
import createActivityStep from "../create_activity_step";
import createActivityStep2 from "../create_activity_step2";
import statistics from "../activity_data_statistics";
import statisticsNew from "../activity_data_statistics_new.vue";
import createTaskElectric from "../points_task_electric.vue";
import createTaskPolite from "../points_task_polite.vue";
import createTaskEvaluation from "../points_task_evaluation.vue";
import pointsTaskGames from "../points_task_games.vue";
import createTaskBook from "../points_task_book.vue";
import createActivityOrder from "../create_activity_order";
import giftList from "../gift_list.vue";
import memberdataanalysis from "../memberCenter/member-data-analysis.vue";
import member from "./member.vue";
import dataAnalysis from "../memberCenter/data-analysis.vue";
import qrcodeVue from "qrcode-vue";
import createTaskSuperFission from "../points_task_superFission.vue";
import createBrithday from "../create-brithday";
import whiteList from "../components/whiteList.vue";
import createSinglesPolitely from "../create_singles_politely.vue";
import winSearch from "../win_search.vue";
import memberUpgradePage from "@/views/integralCenter/member_upgrade_page.vue";
import billetDouxGreetingCard from "@/views/integralCenter/billet-doux-greeting-card.vue";

import {
  queryActivity,
  endEvent,
  deleteEvent,
  getActivitySetting,
  saveActivitySetting,
} from "@/api/activityController";
import {
  searchfocusStores,
  editfollow,
  editInformation,
} from "@/api/integralCenter/integralTask";
import {
  getbigTurn,
  prefixurl,
  giftBagEide,
  thousandGiftDetail,
  activityDetail,
} from "@/api/paradiseAndTaskCommonController.js";
export default {
  components: {
    memberdataanalysis,
    dataAnalysis,
    member,
    giftList,
    qrcodeVue,
    createTaskBook,
    inputForm,
    pointsTaskActivity,
    createActivityStep,
    createActivityStep2,
    createInviteStep,
    createActivityOrder,
    statistics,
    createTaskElectric,
    createTaskPolite,
    createTaskEvaluation,
    pointsTaskGames,
    memberdataanalysis,
    createTaskSuperFission,
    whiteList,
    statisticsNew,
    createBrithday,
    createSinglesPolitely,
    winSearch,
    memberUpgradePage,
    billetDouxGreetingCard,
  },
  data() {
    return {
      actItemInfo: true,
      activityNewMainTypes: 1,
      form: {
        activityName: "",
        activityType: "",
        activityNewMainTypes: 1,
        status: "",
      },
      selectArr: [
        {
          value: 1,
          label: "日常玩法",
        },
        {
          value: 2,
          label: "无线营销",
        },
        {
          value: 3,
          label: "裂变营销",
        },
        {
          value: 4,
          label: "趣味抽奖",
        },
        {
          value: 5,
          label: "游戏中心",
        },
        {
          value: 6,
          label: "会员商城",
        },
        {
          value: 7,
          label: "会员权益",
        },
      ],
      selectArr1: [],
      qrcodeVue: {
        size: 250,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      backgroundOpacity: false,
      isDraftEdit: false,
      statusComment: false,
      isSave: true,
      pageName: "忠诚度管理-积分-活动管理",
      talbeLoading: false,
      qrcode: null,
      outerVisible: false,
      outerVisibleTwo: false,
      valueRow: {},
      createVal: 0,
      activityDataTwo: {
        telImg: require("../../../assets/images/integralCenter/night_m.png"),
        telCode: require("../../../assets/images/integralCenter/code.png"),
        id: 1,
        name: "幸运抽奖",
      },
      activityData: {},
      createStep: 1,
      activityList: [],
      // 头部表单配置项
      inputData: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },
        {
          name: "活动类型:",
          val: "activityType",
          placeholder: "请输入活动名称",
          selectArr: [
            // { label: "全部", id: null },
            // { label: "签到赢好礼", id: 1 },
            // { label: "每日抢好礼", id: 3 },
            // { label: "关注店铺有礼", id: 4 },
            // { label: "邀请开卡有礼", id: 5 },
            // { label: "邀请关注有礼", id: 6 },
            // { label: "完善信息有礼", id: 7 },
            // { label: "开卡礼包", id: 13 },
            // { label: "店铺礼包", id: 14 },
            // { label: "店铺礼包（千人千面）", id: 15 },
            // { label: "下单有礼", id: 16 },
            // { label: "首单专享礼", id: 17 },
            // { label: "复购有礼", id: 18 },
            // { label: "下单抽奖", id: 19 },
            // { label: "评价有礼", id: 20 },
            // { label: "裂变神券", id: 21 },
            // { label: "天降红包雨", id: 22 },
            // { label: "预售有礼", id: 27 },
            // { label: "预售抽奖", id: 28 },
          ],
        },
        {
          name: "活动时间:",
          myDate: true,
          noInitValue: true, // 不用给初始化值
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      inputData2: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },

        {
          name: "活动时间:",
          noInitValue: true,
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      currentPage: 1,
      totalNum: 0,
      recordData: {
        size: 10,
        current: 1,
      },
      rowData: {},
      ids: "",
      ids1: "",
      activityUrl: "",
      venderId: "",
      aaa: "",
      status: 1,
      mytimestart: "",
      mytimeend: "",
      opentime: true,
      tabSwitchList: ["全部", "进行中", "未开始", "已结束", "草稿箱"],
      currIndex: 0,
      isStart: false,
      isCopy: false,
      isShowActivityConfig: false, // 显示活动配置弹窗
      activityConfig: {
        checkExistOrder: 0,
        id: "",
      },
      configLoading: false,
      showWhiteList: false,
      whiteRow: {},
      isNew: false, // 是否新版本
    };
  },

  mounted() {
    // this.time();
    this.prefixQue();
    this.selectList();

    //从京东调过来直接进入数据统计页面
    console.log("从京东调过来直接进入数据统计页面", this.$route.query.outId);
    if (this.$route.query.outId) {
      this.jdInit(this.$route.query.outId);
    }
  },

  methods: {
    // 新版本切换
    triggerVersion(val) {
      this.isNew = val;
    },
    handleshow(row) {
      this.actItemInfo = row;
    },
    typeFilter(type) {
      if (
        this.form.activityNewMainTypes == 6 ||
        this.form.activityNewMainTypes == 7
      ) {
        return false;
      } else if ([13, 14, 15].includes(Number(type))) {
        return false;
      } else {
        return true;
      }
    },
    async jdInit(id) {
      const { data: item } = await activityDetail({
        id: id,
        activityType: 0,
      });
      this.rowData = item;
      this.ids1 = item.id;
      this.createStep = 3;
    },
    handleAnysis(row) {
      console.log(row);
      this.ids = row.id;
      if (row.type == 11) this.createStep = 11;
      if (row.type == 12) this.createStep = 12;
    },
    statisDataCreate(row) {
      this.rowData = row;
      this.ids1 = row.id;
      this.createStep = 3;
      this.isNew = true;
      this.handleshow(false);
    },
    handleTab(i) {
      this.currIndex = i;
      if (i == 0) this.form.status = "";
      if (i == 1) this.form.status = 2;
      if (i == 2) this.form.status = 1;
      if (i == 3) this.form.status = 3;
      if (i == 4) this.form.status = 5;
      // this.queryList();
      if (
        this.form.activityNewMainTypes != 6 &&
        this.form.activityNewMainTypes != 7
      )
        this.queryList();
      this.$nextTick(() => {
        if (this.form.activityNewMainTypes == 6)
          this.$refs["giftList"].searchClick(this.form);
        if (this.form.activityNewMainTypes == 7)
          this.$refs["member"].searchClick(this.form);
      });
    },
    handkeSearch(i) {
      if (i == 1) {
        this.form.activityNewMainTypes = 1;
        this.form.activityName = "";
        this.form.activityType = "";
      }
      this.activityNewMainTypes = this.form.activityNewMainTypes;
      if (
        this.form.activityNewMainTypes != 6 &&
        this.form.activityNewMainTypes != 7
      )
        this.queryList();
      // if (this.form.activityNewMainTypes == 6) this.$refs["giftList"].searchClick(this.form);
      // if (this.form.activityNewMainTypes == 7) this.$refs["member"].searchClick(this.form);
      this.$nextTick(() => {
        if (this.form.activityNewMainTypes == 6)
          this.$refs["giftList"].searchClick(this.form);
        if (this.form.activityNewMainTypes == 7)
          this.$refs["member"].searchClick(this.form);
      });
    },
    //时间拼装
    time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = `${this.getDateStr(-30)} 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg(id) {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode${id} img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
        src:
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/ee38b111bb964da7aeb7d67fe4317a51.png",
      });
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
          // this.$store.state.venderId = res.data.venderId;
          // this.queryList();
          // this.form.status = this.$route.query.type
          // this.queryList();
          console.log(this.$route, 3333);
          if (this.$route.query.type) {
            this.handleTab(this.$route.query.type);
          } else {
            this.queryList();
          }
        })
        .catch((res) => {});
    },
    //活动管理查询
    queryList() {
      this.talbeLoading = true;
      this.recordData.activityNewMainTypes = this.$route.meta.activityNewMainTypes;
      this.activityList.forEach((item, index) => {
        var ref = "qrcode" + item.id;
        this.$nextTick(() => {
          if (item.id && this.$refs[ref]) {
            this.$refs[ref].innerHTML = "";
          }
        });
      });
      this.talbeLoading = true;
      queryActivity({ ...this.recordData, ...this.form }).then((res) => {
        this.talbeLoading = false;
        let mesUrl = "";
        this.activityList = res.data.records.map((item) => {
          return {
            ...item,
            days: this.DayHours(item.startTime, item.endTime, item.status),
          };
        });
        this.totalNum = Number(res.data.total);
        this.activityList.forEach((item, index) => {
          // 二维码进小程序
          let xcxUrl = this.$commonUrl();
          let options = {
            activityId: item.id,
            venderId: this.venderId,
            activityType: item.activityType,
          };
          let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A111%2C%22index%22%3A222%7D`;
          let pcParams = encodeURIComponent(
            Object.keys(options)
              .map((item) => `${item}=${options[item]}`)
              .join("&")
          );
          // 1：签到赢好礼
          if (item.activityType == 1) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/signPolite/signPolite.html%3fitem%3d" +
              params1;
          }
          // 2：浏览礼品有礼
          // if (item.activityType == 2) {
          //   item.idUrl = ""
          // }
          // 3：每日抢好礼
          if (item.activityType == 3) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/robGoodPresent/robGoodPresent.html%3fitem%3d" +
              params1;
          }
          // 4：关注店铺有礼
          if (item.activityType == 4) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/attentionShop/attentionShop.html%3fitem%3d" +
              params1;
          }
          //  5：邀请开卡有礼
          if (item.activityType == 5) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/inviteCard/inviteCard.html%3fitem%3d" +
              params1;
            item.pcUrl = `${xcxUrl}pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
          }
          //  6：邀请关注店铺
          if (item.activityType == 6) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/invite/invite.html%3fitem%3d" +
              params1;
          }
          // 7：完善信息有礼
          if (item.activityType == 7) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/perfect_information/perfect_information.html%3fitem%3d" +
              params1;
          }
          //  8：幸运抽奖
          if (item.activityType == 8) {
            item.idUrl =
              xcxUrl +
              "pages/interactPark/bigTurntable/bigTurntable.html%3fitem%3d" +
              params1;
          }
          //  京获客1.2 下单复购首单
          if (
            item.activityType == 16 ||
            item.activityType == 17 ||
            item.activityType == 18
          ) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/ordergift/ordergift.html%3fitem%3d" +
              params1;
            item.pcUrl = `${xcxUrl}pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
          }
          //  19：下单抽奖
          if (item.activityType == 19) {
            item.idUrl =
              xcxUrl +
              "pages/interactPark/placeOrder/placeOrder.html%3fitem%3d" +
              params1;
          }
          //  京获客1.3 评价有礼
          if (item.activityType == 20) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/evaluation_gift/evaluation_gift.html%3fitem%3d" +
              params1;
          }
          //  京获客1.3 裂变神券
          if (item.activityType == 21) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/groupCoupon/groupCoupon.html%3fitem%3d" +
              params1;
          }
          //  京获客1.3 红包雨
          if (item.activityType == 22) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/redPacketRain/redPacketRain.html%3fitem%3d" +
              params1;
          }
          //  京获客1.4 疯狂抓娃娃
          if (item.activityType == 23) {
            item.idUrl =
              xcxUrl +
              "pages/gameCore/catchDoll/catchDoll.html%3fitem%3d" +
              params1;
          }
          //  京获客1.4 欢乐娃娃机
          if (item.activityType == 24) {
            item.idUrl =
              xcxUrl +
              "pages/gameCore/seekDistinct/seekDistinct.html%3fitem%3d" +
              params1;
          }
          //  预售有礼
          if (item.activityType == 27) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/preGift/preGift.html%3fitem%3d" +
              params1;
          }
          //  预售抽奖
          if (item.activityType == 28) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/prePrize/prePrize.html%3fitem%3d" +
              params1;
          }
          //  超级裂变
          if (item.activityType == 31) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/superCoupon/superCoupon.html%3fitem%3d" +
              params1;
          }
          // 加购有礼
          if (item.activityType == 34) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/addCart/addCart.html%3fitem%3d" +
              params1;
          }
          if (item.activityType == 13) {
            item.idUrl = "http://yq-hd-rc.isvjcloud.com/shop.html";
          }
          if (item.activityType == 14) {
            item.idUrl = "http://yq-hd-rc.isvjcloud.com/shop.html";
          }
          if (item.activityType == 36) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/orderRisk/orderRisk.html%3fitem%3d" +
              params1;
          }
          if (item.activityType == 37) {
            // 珀莱雅的活动单独处理，后续可能所有活动统一处理
            params1 = `activityId%3D${options.activityId}%26venderId%3D${options.venderId}%26activityType%3D${options.activityType}`;
            item.idUrl =
              xcxUrl +
              "pages/interactTask/sampleBuyback/sampleBuyback.html%3f" +
              params1;
          }
          // 生日有礼
          if (item.activityType == 39) {
            item.idUrl =
              xcxUrl +
              "pages/interactTask/birthGift/birthGift.html%3fitem%3d" +
              params1;
          }

          // 会员升级礼
          if (item.activityType == 44) {
            item.idUrl =
              xcxUrl +
              "pages/upgradeMember/upgradeMember.html%3fitem%3d" +
              params1;
          }
          // 情书贺卡
          if (item.activityType == 50) {
            item.idUrl =
              xcxUrl +
              "pages/loveLettersCards/loveLettersCards.html%3fitem%3d" +
              params1;
          }
          //晒单有礼
          if (item.activityType == 41) {
            item.idUrl =
              xcxUrl + "pages/hwCustomize/hwCustomize.html%3fitem%3d" + params1;
            item.pcUrl = `${xcxUrl}pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
          }
          // this.$nextTick(() => {
          //   let queryId = "qrcode" + item.id;
          // });
        });
      });
    },
    selectList() {
      this.form.activityType = "";
      if (this.form.activityNewMainTypes == 1) {
        this.selectArr1 = [
          { label: "全部", id: null },
          { label: "签到赢好礼", id: 1 },
          // { label: "浏览商品有礼", id: 2 },
          { label: "每日限时抢", id: 3 },
          { label: "关注店铺有礼", id: 4 },
          // { label: "邀请开卡有礼", id: 5 },
          // { label: "邀请关注店铺", id: 6 },
          { label: "完善信息有礼", id: 7 },
          // { label: "开卡礼包", id: 13 },
          // { label: "店铺礼包", id: 14 },
          // { label: "店铺礼包（千人千面）", id: 15 },
          // { label: "下单有礼", id: 16 },
          // { label: "首单专享礼", id: 17 },
          // { label: "复购有礼", id: 18 },
          // { label: "下单抽奖", id: 19 },
          // { label: "评价有礼", id: 20 },
          // { label: "裂变神券", id: 21 },
          // { label: "天降红包雨", id: 22 },
          // { label: "预售有礼", id: 27 },
          // { label: "预售抽奖", id: 28 },
          { label: "加购有礼", id: 34 },
          { label: "生日有礼", id: 39 },
          { label: "会员升级礼", id: 44 },
        ];
      }
      if (this.form.activityNewMainTypes == 2) {
        this.selectArr1 = [
          { label: "全部", id: null },
          { label: "开卡礼包", id: 13 },
          { label: "店铺礼包", id: 14 },
          { label: "店铺礼包（千人千面）", id: 15 },
          { label: "预售有礼", id: 27 },
          { label: "预售抽奖", id: 28 },
          { label: "首单专享礼", id: 17 },
          { label: "复购有礼", id: 18 },
          { label: "下单有礼", id: 16 },
          { label: "下单抽奖", id: 19 },
          { label: "下单冲榜", id: 36 },
          { label: "评价有礼", id: 20 },
          { label: "晒单有礼", id: 41 },
        ];
      }
      if (this.form.activityNewMainTypes == 3) {
        this.selectArr1 = [
          { label: "全部", id: null },
          { label: "邀请开卡有礼", id: 5 },
          { label: "邀请关注有礼", id: 6 },
          { label: "裂变神券", id: 21 },
          { label: "超级裂变神券", id: 31 },
          { label: "情书贺卡", id: 50 },
        ];
      }
      if (this.form.activityNewMainTypes == 4) {
        this.selectArr1 = [
          { label: "全部", id: null },
          { label: "幸运抽奖", id: 8 },
        ];
      }
      if (this.form.activityNewMainTypes == 5) {
        this.selectArr1 = [
          { label: "全部", id: null },
          { label: "天降红包雨", id: 22 },
          { label: "欢乐娃娃机", id: 23 },
          { label: "大家来找茬", id: 24 },
        ];
      }
      if (this.form.activityNewMainTypes == 6) {
        this.selectArr1 = [
          { label: "全部", id: null },
          { label: "兑换优惠券", id: 10 },
          { label: "兑换实物", id: 9 },
          { label: "兑换京豆", id: 29 },
          { label: "兑换E卡", id: 30 },
          { label: "兑换爱奇艺会员", id: 58 },
          { label: "兑换京东PLUS会员", id: 59 },
          { label: "兑换礼品卡", id: 60 },
          { label: "兑换百度网盘", id: 61 },
        ];
      }
      if (this.form.activityNewMainTypes == 7) {
        this.selectArr1 = [
          { label: "全部", id: null },
          { label: "新人优惠券", id: 11 },
          { label: "会员券", id: 12 },
        ];
      }
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteEvent(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              this.queryList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
    //结束确定
    handleDeleteTable() {
      let id = this.ids;
      endEvent(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("操作成功");
            this.outerVisible = false;
            this.queryList();
          }
        })
        .catch(() => {
          if (res.code == 10100) {
            this.$message.error("活动未开始不能结束活动");
            this.outerVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    returnStep() {
      this.createStep = 1;
      this.recordData.current = 1;
      this.recordData.size = 10;
      // this.prefixQue();
      this.$nextTick(() => {
        if (
          this.form.activityNewMainTypes != 6 &&
          this.form.activityNewMainTypes != 7
        )
          this.queryList();
        if (this.form.activityNewMainTypes == 6)
          this.$refs["giftList"].searchClick(this.form);
        if (this.form.activityNewMainTypes == 7)
          this.$refs["member"].searchClick(this.form);
      });
      // console.log(this.recordData,99988);
    },
    createActivity(type,val) {
      // 用于生成二维码
      let coverSrc =
        "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/";
      if (type == 5) {
        this.createStep = 5;
        this.activityData = {
          id: 4,
          name: "邀请开卡有礼",
          telImg: require("../../../assets/thdImg/cover/kk.png"),
          telCode: coverSrc + "yqgz.png",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
        return;
      }
      if (type == 16 || type == 17 || type == 18) {
        this.createStep = 16;
        switch (type) {
          case 16:
            this.activityData = {
              id: 16,
              name: "下单有礼",
              telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "下单有礼";
            break;
          case 17:
            this.activityData = {
              id: 17,
              name: "首单专享礼",
              telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "首单专享礼";
            break;
          case 18:
            this.activityData = {
              id: 18,
              name: "复购有礼",
              telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "复购有礼";
            break;
        }
        return;
      }
      if (type == 27 || type == 28) {
        this.createStep = 27;
        switch (type) {
          case 27:
            this.activityData = {
              id: 27,
              name: "预售有礼",
              telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "预售有礼";
            break;
          case 28:
            this.activityData = {
              id: 28,
              name: "预售抽奖",
              telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "预售抽奖";
            break;
        }
        return;
      }
      if (type == 20 || type == 21 || type == 22) {
        this.createStep = 20;
        switch (type) {
          case 20:
            this.activityData = {
              id: 20,
              name: "评价有礼",
              telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "评价有礼";
            break;
          case 21:
            this.activityData = {
              id: 21,
              name: "裂变神券",
              telImg: require("../../../assets/thdImg/cover/lbsq.png"),
              telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=21`,
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "裂变神券";
            break;
          case 22:
            this.activityData = {
              id: 22,
              name: "天降红包雨",
              telImg: require("../../../assets/thdImg/cover/tjhby.png"),
              telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=22`,
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "天降红包雨";
            break;
        }
        return;
      }
      if (type == 15) {
        this.createStep = 15;
        this.activityData = {
          id: 15,
          name: "店铺礼包千人千面",
          telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
          telCode: "",
          isCopy: this.isCopy,
          status: val.status,
        };
        this.titleName = "店铺礼包千人千面";
        return;
      }
      if (type == 36) {
        this.createStep = 36;
        this.activityData = {
          id: 36,
          name: "下单冲榜",
          telImg: require("../../../assets/images/integralCenter/dingzhi.png"),
          telCode: "",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
        this.titleName = "下单冲榜";
        return;
      }
      let idUrl1 = `https://yq-hd-rc.isvjcloud.com/clientPreview?activityType=11&venderId=${this.$store.state.loginUserInfo.venderId}`;
      this.createStep = 2;
      switch (type) {
        case 1:
          this.activityData = {
            id: 1,
            name: "签到赢好礼",
            telImg: require("../../../assets/images/integralCenter/qdq.jpg"),
            // telImg: require("../../../assets/images/integralCenter/日历签到1.png"),
            // telImg2: require("../../../assets/images/integralCenter/日历签到2.png"),
            // telImg3: require("../../../assets/images/integralCenter/日历签到3.png"),
            // telCode: require("../../../assets/images/integralCenter/code.png"),
            // telCode: idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "1" }),
            // telCode2: idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "2" }),
            // telCode3: idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "3" }),
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 3:
          this.activityData = {
            id: 2,
            name: "每日限时抢",
            telImg: require("../../../assets/thdImg/cover/mrq.png"),
            telCode: `https://yq-hd-rc.isvjcloud.com/rob_goodPresent?venderId=${this.$store.state.loginUserInfo.venderId}`,
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 4:
          this.activityData = {
            id: 3,
            name: "关注店铺有礼",
            telImg: require("../../../assets/thdImg/cover/gzdp.png"),
            telCode: `https://yq-hd-rc.isvjcloud.com/attention_shop?venderId=${this.$store.state.loginUserInfo.venderId}`,
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 5:
          this.activityData = {
            id: 4,
            name: "邀请开卡有礼",
            telImg: require("../../../assets/images/integralCenter/kk.jpg"),
            telCode: require("../../../assets/images/integralCenter/code.png"),
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 6:
          this.activityData = {
            id: 5,
            name: "邀请关注有礼",
            telImg: require("../../../assets/thdImg/cover/yqgz.png"),
            telCode: coverSrc + "yqkk.png",
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 7:
          this.activityData = {
            id: 6,
            name: "完善信息有礼",
            telImg: require("../../../assets/thdImg/cover/wsxx.png"),
            telCode: `https://yq-hd-rc.isvjcloud.com/perfect_information?venderId=${this.$store.state.loginUserInfo.venderId}`,
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 13:
          this.activityData = {
            id: 13,
            name: "开卡礼包",
            isCopy: this.isCopy,
          };
          break;
        case 14:
          this.activityData = {
            id: 14,
            name: "店铺礼包",
            isCopy: this.isCopy,
            status: val.status,
          };
          break;
        case 34:
          this.activityData = {
            id: 34,
            name: "加购有礼",
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
      // this.changeStatus();
      // this.prefixQue();
    },
    saveEditChange() {
      this.createStep = 1;
      this.tabActive = 2;
      this.changeStatus();
      setTimeout(() => {
        this.queryList();
      }, 1000);
    },

    //大转盘管理查询

    // 表单查询
    searchForm(form) {
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName;
      this.recordData.activityType = form.activityType;
      this.recordData.startTime = form.startTime;
      this.recordData.endTime = form.endTime;
      this.recordData.startUpdateTime = form.startUpdateTime;
      this.recordData.endUpdateTime = form.endUpdateTime;
      this.recordData.status = form.status;
      console.log("form:", this.recordData);
      this.queryList();
    },

    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.queryList();
    },

    //结束活动
    endenActivity(id) {
      // console.log(123);
      this.outerVisible = true;
      this.ids = id;
    },

    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    //修改
    modify(row, val, type = "edit", status) {
      // type==edit 为修改
      this.backgroundOpacity = type == "look" ? true : false;
      // 进行中的活动  去掉保存按钮
      // copy复制   复制需要跳转至选择模板页面
      this.stepNum = type == "copy" ? 0 : 1;
      this.isCopy = type == "copy" ? true : false;
      this.isDraftEdit = type == "draft" ? true : false;
      // V2.5需求  进行中活动可修改  复制不影响
      if (status == 2 && type == "edit") {
        this.isStart = true;
      } else {
        this.isStart = false;
      }
      if (type != "copy") {
        // if (val.status == 2) {
        //   this.isSave = false;
        // } else {
        //   this.isSave = true;
        // }
        // 评价有礼 修改禁用一些输入框
        // this.statusComment = false;
        if (row == 20) {
          this.isSave = false;
          // if (val.status == 2) {
          //   this.statusComment = false;
          // } else {
          this.statusComment = true;
          // }
        } else {
          this.isSave = true;
        }
      }
      if (row == 8) {
        console.log("val:", val, this.isCopy, this.isStart);
        this.activityDataTwo = {
          telImg: require("../../../assets/images/integralCenter/night_m.png"),
          telCode: require("../../../assets/images/integralCenter/code.png"),
          id: val.activityType,
          name: "幸运抽奖",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
        this.createStep = 4;
        // this.stepNum = 1;
        this.ids = val.id;
      } else if (row == 19) {
        this.activityDataTwo = {
          telImg: require("../../../assets/images/integralCenter/night_m.png"),
          telCode: require("../../../assets/images/integralCenter/code.png"),
          id: 19,
          name: "下单抽奖",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
        this.createStep = 19;
        // this.stepNum = 1;
        this.ids = val.id;
      } else if (row == 23 || row == 24) {
        this.activityData = {
          telImg: require("../../../assets/images/integralCenter/night_m.png"),
          telCode: require("../../../assets/images/integralCenter/code.png"),
          id: row,
          name: row == 23 ? "欢乐娃娃机" : "大家来找茬",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
        this.createStep = 23;
        this.valueRow = val;
        this.activeValue = row;
        // this.stepNum = 1;
        // this.ids = val.id;
      } else if (row == 15) {
        this.createStep = 15;
        this.createActivity(row, val);
        // this.stepNum = 1;
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 16 || row == 17 || row == 18) {
        this.createStep = 16;
        this.createActivity(row, val);
        // this.stepNum = 1;
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 20 || row == 21 || row == 22) {
        this.createStep = 20;
        this.createActivity(row, val);
        // this.stepNum = 1;
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 27 || row == 28) {
        this.createStep = 27;
        this.createActivity(row, val);
        // this.stepNum = 1;
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 31) {
        this.createStep = 31;
        // this.createActivity(row);
        // this.stepNum = 1;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 31,
          name: "超级裂变券",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row == 39) {
        this.createStep = 39;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 39,
          name: "生日有礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      }else if (row == 44) {
        this.createStep = 44;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 44,
          name: "会员升级礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row == 50) {
        this.createStep = 50;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 50,
          name: "情书贺卡",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      }else if (row == 41) {
        this.createStep = 41;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 41,
          name: "晒单有礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else {
        this.createStep = 2;
        this.createActivity(row, val);
        // this.stepNum = 1;
        this.valueRow = val;
        this.activeValue = row;
      }
      // console.log(this.createStep);
      this.$emit("changeData");
    },
    changeStatus() {
      this.$emit("changeStatus");
    },
    //数据统计
    statisData(row) {
      this.rowData = row;
      console.log(row, "25896");
      this.ids1 = row.id;
      this.createStep = 3;
      // 判断活动时间是否为新版
      this.isNew = this.isCurrentTimeAfter(row.createTime);
    },
    handleback(type) {
      this.$emit("goback", type);
    },
    // 二维码预览
    async handleMouseover(row, index) {
      if (row.activityType == "15") {
        const { data: res } = await thousandGiftDetail(row.id);
        const prizesllist =
          res.sceneList.length > 0 ? res.sceneList[0].prizes : "";
        const prizes = prizesllist.map((item) => {
          return { title: item.title };
        });
        const giftTemplateUrl =
          res.sceneList.length > 0 ? res.sceneList[0].giftTemplateUrl : "";
        const buttonText =
          res.sceneList.length > 0 && res.sceneList[0].buttonText
            ? res.sceneList[0].buttonText
            : "";
        const text1 = `http://yq-hd-rc.isvjcloud.com/shop.html?image=${giftTemplateUrl}buttom=${encodeURIComponent(
          JSON.stringify(buttonText)
        )}text=${encodeURIComponent(JSON.stringify(prizes))}`;
        this.activityList = this.activityList.map((item) => {
          if (row.id == item.id) {
            item.idUrl = text1;
          }
          return item;
        });
        this.activityList = this.activityList.map((item) => {
          if (item.id == row.id) {
            item.idUrl = text1;
          }
          return item;
        });
        // document.querySelector(`#qrcode${row.id}`).innerHTML = "";
        // new QRCode("qrcode" + row.id, {
        //   width: 200, // 设置宽度，单位像素
        //   height: 200, // 设置高度，单位像素
        //   text: text1, // 设置二维码内容或跳转地址
        // });
      } else {
        const { data: res } = await giftBagEide(row.id);
        const prizes = res.prizes ? res.prizes : "";
        const giftTemplateUrl = res.giftTemplateUrl ? res.giftTemplateUrl : "";
        const buttonText =
          res.ruleDto && res.ruleDto.buttonText ? res.ruleDto.buttonText : "";
        const text = `http://yq-hd-rc.isvjcloud.com/shop.html?image=${giftTemplateUrl}`;
        const text1 = `http://yq-hd-rc.isvjcloud.com/shop.html?image=${giftTemplateUrl}buttom=${encodeURIComponent(
          JSON.stringify(buttonText)
        )}text=${encodeURIComponent(JSON.stringify(prizes))}`;
        // this.activityList[index].idUrl = row.activityType == "13" ? text : text1;
        this.activityList = this.activityList.map((item) => {
          if (row.id == item.id) {
            item.idUrl = row.activityType == "13" ? text : text1;
          }
          return item;
        });
        this.activityList = this.activityList.map((item) => {
          if (item.id == row.id) {
            item.idUrl = item.activityType == "13" ? text : text1;
          }
          return item;
        });
        // document.querySelector(`#qrcode${row.id}`).innerHTML = "";
        // new QRCode("qrcode" + row.id, {
        //   width: 200, // 设置宽度，单位像素
        //   height: 200, // 设置高度，单位像素
        //   text: row.activityType == "13" ? text : text1, // 设置二维码内容或跳转地址
        // });
      }
    },
    DayHours(start, end, status) {
      // let startTime = new Date(start);
      // let endTime = new Date(end);
      let nowTime = this.formatDate(new Date());
      let res = "";
      // 未开始
      if (status == 1) {
        let arr = this.timediff(start, nowTime);
        res = arr[0] + "天" + arr[1] + "小时" + arr[2] + "分后开始";
      }
      // 进行中
      if (status == 2) {
        let arr = this.timediff(start, nowTime);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      // 已结束
      if (status == 3) {
        let arr = this.timediff(start, end);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      return res;
    },
    timediff(begin_time, end_time) {
      //年月日时分秒转换为时间戳
      let beginTime = new Date(begin_time).getTime() / 1000;
      let endTime = new Date(end_time).getTime() / 1000;
      var starttime = "";
      var endtime = "";
      if (beginTime < endTime) {
        starttime = beginTime;
        endtime = endTime;
      } else {
        starttime = endTime;
        endtime = beginTime;
      }
      //计算天数
      var timediff = endtime - starttime;
      var days = parseInt(timediff / 86400);
      //计算小时数
      var remain = timediff % 86400;
      var hours = parseInt(remain / 3600);
      //计算分钟数
      var remain = remain % 3600;
      var mins = parseInt(remain / 60);
      // var res = days + "天" + hours + "小时" + mins + "分";
      return [days, hours, mins];
    },
    formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
      let currentDate = new Date(date);
      let o = {
        "M+": currentDate.getMonth() + 1, //月份
        "d+": currentDate.getDate(), //日
        "h+": currentDate.getHours(), //小时
        "m+": currentDate.getMinutes(), //分
        "s+": currentDate.getSeconds(), //秒
        "q+": Math.floor((currentDate.getMonth() + 3) / 3), //季度
        S: currentDate.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    // 打开弹窗获取配置
    handleSetConfig() {
      this.isShowActivityConfig = true;
      this.getActivityConfig();
    },
    //保存配置
    handleConfirmConfig() {
      this.isShowActivityConfig = false;
      saveActivitySetting(this.activityConfig)
        .then((res) => {
          this.$message.success("保存成功");
        })
        .catch(() => {
          this.$message.error("保存失败");
        });
    },
    beforeConfigclose() {
      this.isShowActivityConfig = false;
    },
    //获取活动配置
    getActivityConfig() {
      this.configLoading = true;
      getActivitySetting()
        .then((res) => {
          if (res.data && "checkExistOrder" in res.data) {
            let { checkExistOrder, id } = res.data;
            this.activityConfig.checkExistOrder = checkExistOrder;
            this.activityConfig.id = id;
          }
        })
        .catch(() => {
          this.$message.error("获取失败");
        })
        .finally(() => {
          this.configLoading = false;
        });
    },
    // 下单抽奖添加白名单
    addWhiteList(row) {
      this.whiteRow = row;
      this.showWhiteList = true;
    },
    // 编辑草稿箱
    editDraft(row) {
      this.modify(row.activityType, row, "draft", 5);
    },
    // 删除草稿箱
    delDraft(row) {
      this.status = row.status;
      this.ids = row.id;
      this.outerVisibleTwo = true;
    },
    // 中奖查询
    handleWinSearch() {
      this.createStep = 500;
    },
  },
};
</script>

<style lang="scss" scoped>
.draft-btn {
  width: auto;
  padding: 0px !important;
}
.no-white {
  width: 42px;
}
.formClass {
  margin: 24px 0;
  display: flex;
  /deep/.el-form-item {
    margin-right: 50px;
  }
  .seach_btn {
    margin-left: auto;
    margin-right: 30px;
    display: flex;
  }
  .search,
  .reset {
    width: 98px;
    font-size: 14px;
    height: 32px;
    transition: all 0.2s;
    border-radius: 4px 4px 4px 4px;
  }
  .search {
    color: #fff;
    background-color: #7b61ff;
    &:hover {
      opacity: 0.8;
    }
  }
  .reset {
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background: rgba(38, 112, 251, 0.1);
    }
  }
}
.tabSwitch {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  // padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  &-wz {
    height: 50px;
    line-height: 50px;
    position: relative;
    margin-right: 24px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #7b61ff;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      background-color: #7b61ff;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.createbox {
  width: 94px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #7b61ff;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  color: #fff;
  background-color: #7b61ff;
  &:hover {
    opacity: 0.8;
  }
}
// .topbox {
//   margin-bottom: 20px;
//   display: flex;
//   align-items: center;
//   font-size: 16px;
//   color: #666;
//   &-back {
//     padding: 8px 15px;
//     border: 1px solid #7b61ff;
//     margin-right: 10px;
//     color: #7b61ff;
//     font-size: 14px;
//     cursor: pointer;
//     &:hover {
//       color: #fff;
//       background-color: #7b61ff;
//     }
//   }
// }
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.marginClass {
  margin: 24px;
}
.activityManage {
  box-sizing: border-box;
  // padding: 20px 28px 30px;
  box-sizing: border-box;
  padding: 24px;
  margin: 24px;
  background: #fff;
  min-height: 87vh;
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-right: 4px;
      cursor: pointer;
    }
    .act-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //设置超出几行省略内容
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .activityTime2 {
    display: flex;
    align-items: center;
    &_line {
      margin: 0px 10px;
    }
  }
  // .y1,
  // .y2,
  // .y3 {
  //   display: inline-block;
  //   width: 6px;
  //   height: 6px;
  //   border-radius: 50%;
  //   margin-right: 5px;
  // }
  .state {
    padding: 6px 10px;
    border-radius: 17px;
  }
  .y1 {
    color: #02b1ff;
    background-color: #e6f7ff;
  }
  .y2 {
    color: #f36f39;
    background: #fef1ec;
  }
  .y3 {
    color: #5b5b5b;
    background: #f1f1f1;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      min-width: 28px;
      cursor: pointer;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #7b61ff;
      // &:hover {
      //   color: #7b61ff;
      // }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #7f85e9;
      text-align: center;
      &:hover {
        color: #7b61ff;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff4f4;
    }
    &:active {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #7b61ff;
    color: #ffffff;
    border-radius: 3px;
    background-color: #7b61ff;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #7b61ff;
    }
    &:active {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff4f4;
    }
  }
}
.question_icon {
  width: 15px;
  height: 15px;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  color: #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
}
// .activityManage/deep/.el_btn {
// display: inline-block;
// }
.table_tip {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .win_search {
    line-height: 19px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(123, 97, 255);
  }
}
</style>
